<!-- MAIN CONTAINER -->
<div class="d-flex flex-column vh-100">

    <!-- FIXED SPACE FOR MAIN NAV BAR-->
    <div class="container">
        <div class="row my-3 py-3">
        </div>
    </div>

    <!-- FORM HEADER -->
    <div class="container">
        <div class="card card-body INN-form justify-content-center mt-4">
            <div class="row">

                <!-- FORM TITLE -->
                <div class="col-12 col-lg-5">
                    <h4 class="card-title lg-3 mb-lg-1 text-body-secondary">
                        <i class="bi bi-clipboard-check me-2 fs-1 text-primary"></i>Proyecto
                    </h4>
                </div>

                <!-- FUNCTIONS BUTTONS -->
                <div class="col ms-2 m-lg-0 d-lg-flex justify-content-lg-end align-items-lg-end">

                    <div *ngIf="opE === '1'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="validaFormulario(false, true)" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                            <i class="bi-pencil-square me-2"></i> Editar
                        </button>
                    </div>

                    <div *ngIf="opE === '1' && rol ==='Administrador'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="eliminar()" class="INN-function-button link-opacity-50-hover text-decoration-none link-danger fs-6">
                            <i class="bi-trash3 me-2"></i>Eliminar
                        </button>
                    </div>

                    <div *ngIf="opE === '2'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="validaFormulario(true, false)" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                           <i class="bi-save me-2"></i>Guardar
                        </button>
                    </div>

                    <div class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="cancelar()" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                            <i [ngClass]="[iconoMostrar, 'me-2']"></i> {{nameBoton}}
                        </button>
                    </div>

                </div>

            </div>
        </div>
    </div>

    <!-- FORM CONTENT -->
    <div class="container pe-6">
        <div class="card card-body INN-form justify-content-center mt-2">
            <form class="needs-validation" novalidate>
                <div class="row g-3">

                    <!-- FIELD -->
                    <div class="col-md-12">
                        <label for="Field" class="form-label">Nombre de Proyecto</label>
                        <input type="text" class="form-control" name="proyecto.nombre" id="proyecto.nombre" [(ngModel)]="proyecto.nombre" #nombre="ngModel" [ngClass]="{'is-invalid': nombre.invalid && (nombre.dirty || nombre.touched)}" (ngModelChange)="mostrarMensaje(nombre, 'nombre')"
                            (blur)="mostrarMensaje(nombre, 'nombre')" required>
                        <p class="invalid-feedback" *ngIf="showErrorMessageNombre">
                            {{mensajeValidacionNombre}}
                        </p>
                    </div>

                    <div class="col-md-6">
                        <label for="Field" class="form-label">Clave del Proyecto</label>
                        <input type="text" class="form-control" name="proyecto.clave" id="proyecto.clave" [(ngModel)]="proyecto.clave" #clave="ngModel" [ngClass]="{'is-invalid': clave.invalid && (clave.dirty || clave.touched)}" (ngModelChange)="mostrarMensaje(clave, 'clave')"
                            (blur)="mostrarMensaje(clave, 'clave')" required>
                        <p class="invalid-feedback" *ngIf="showErrorMessageClave">
                            {{mensajeValidacionClave}}
                        </p>
                    </div>

                    <!-- MENU FIELD -->
                    <div class="col-md-6">
                        <label for="Field" class="form-label">Área de facturación</label>
                        <select class="form-select" name="proyecto.id_dirfact" id="proyecto.id_dirfact" [(ngModel)]="proyecto.id_dirfact" #id_dirfact="ngModel" [ngClass]="{'is-invalid': id_dirfact.invalid && (id_dirfact.dirty || id_dirfact.touched)}" (ngModelChange)="mostrarMensaje(id_dirfact, 'fact')"
                            (blur)="mostrarMensaje(id_dirfact, 'fact')" required>
                          <option value="">Seleccione...</option>
                          <ng-container *ngFor="let area of areas">
                            <option *ngIf="area.Dir_Activo" [value]="area.Id_Direccion">{{ area.Dir_Nombre }}</option>
                          </ng-container>
                        </select>
                        <p class="invalid-feedback" *ngIf="showErrorMessageFact">
                            {{mensajeValidacionFact}}
                        </p>
                    </div>

                    <!-- BAR -->
                    <hr class="mt-4 mb-0">

                    <!-- MENU FIELD -->
                    <div class="col-md-12">
                        <label for="Field" class="form-label">Administrador del proyecto</label>
                        <select id="id_administrador" class="form-select select2" multiple="multiple" name="id_administrador" [(ngModel)]="proyecto.id_administrador" #id_administrador="ngModel" [ngClass]="{'is-invalid': id_administrador.invalid && (id_administrador.dirty || id_administrador.touched)}"
                            (ngModelChange)="mostrarMensaje(id_administrador, 'adm')" (blur)="mostrarMensaje(id_administrador, 'adm')" required>
                            <ng-container *ngFor="let usuario of usuariosAP">
                                <option [value]="usuario.Id_Usuario">
                                {{ usuario.Usr_Nombre }} {{ usuario.Usr_Apellido_Paterno }} {{ usuario.Usr_Apellido_Materno }}
                                </option>
                            </ng-container>
                        </select>
                        <p class="invalid-feedback" [ngStyle]="{ display: showErrorMessageAdm ? 'block' : 'none' }" *ngIf="showErrorMessageAdm">
                            {{mensajeValidacionAdm}}
                        </p>
                    </div>

                    <!-- MENU FIELD -->
                    <div class="col-md-6">
                        <label for="Field" class="form-label">Supervisor del proyecto</label>
                        <select class="form-select" name="proyecto.id_supervisor" id="proyecto.id_supervisor" [(ngModel)]="proyecto.id_supervisor" #id_supervisor="ngModel" [ngClass]="{'is-invalid': id_supervisor.invalid && (id_supervisor.dirty || id_supervisor.touched)}" (ngModelChange)="mostrarMensaje(id_supervisor, 'sup')"
                            (blur)="mostrarMensaje(id_supervisor, 'sup')" required>
                          <option value="">Seleccione...</option>
                          <ng-container *ngFor="let usuario of usuariosS">
                            <option *ngIf="usuario.Usr_Activo" [value]="usuario.Id_Usuario">{{ usuario.Usr_Nombre }} {{usuario.Usr_Apellido_Paterno}} {{usuario.Usr_Apellido_Materno}}</option>
                          </ng-container>
                        </select>
                        <p class="invalid-feedback" *ngIf="showErrorMessageSup">
                            {{mensajeValidacionSup}}
                        </p>
                    </div>

                    <!-- MENU FIELD -->
                    <div class="col-md-6">
                        <label for="Field" class="form-label">Responsable de unidad de negocio</label>
                        <select class="form-select" name="proyecto.id_responsable" id="proyecto.id_responsable" [(ngModel)]="proyecto.id_responsable" #id_responsable="ngModel" [ngClass]="{'is-invalid': id_responsable.invalid && (id_responsable.dirty || id_responsable.touched)}"
                            (ngModelChange)="mostrarMensaje(id_responsable, 'resp')" (blur)="mostrarMensaje(id_responsable, 'resp')" required>
                            <option value="">Seleccione...</option>
                            <ng-container *ngFor="let usuario of usuariosD">
                            <option *ngIf="usuario.Usr_Activo" [value]="usuario.Id_Usuario">{{ usuario.Usr_Nombre }} {{usuario.Usr_Apellido_Paterno}} {{usuario.Usr_Apellido_Materno}}</option>
                            </ng-container>
                        </select>
                        <p class="invalid-feedback" *ngIf="showErrorMessageResp">
                            {{mensajeValidacionResp}}
                        </p>
                    </div>

                    <!-- BAR -->
                    <hr class="mt-4 mb-0">

                    <!-- DATE PICKER-->
                    <div class="col-md-6">
                        <label for="date" class="form-label">Fecha de inicio de proyecto</label>
                        <div class="input-group">
                            <input class="form-control" type="date" name="proyecto.fecha_inicio" [(ngModel)]="proyecto.fecha_inicio" #fecha_inicio="ngModel" [ngClass]="{'is-invalid': fecha_inicio.invalid && (fecha_inicio.dirty || fecha_inicio.touched)}" (ngModelChange)="mostrarMensaje(fecha_inicio, 'ini')"
                                (blur)="mostrarMensaje(fecha_inicio, 'ini')" required>
                        </div>
                        <p class="invalid-feedback" *ngIf="showErrorMessageIni">
                            {{mensajeValidacionIni}}
                        </p>
                    </div>

                    <!-- DATE PICKER-->
                    <div class="col-md-6">
                        <label for="date" class="form-label">Fecha de fin de proyecto</label>
                        <div class="input-group">
                            <input class="form-control" type="date" name="proyecto.fecha_fin" [(ngModel)]="proyecto.fecha_fin" #fecha_fin="ngModel" [ngClass]="{'is-invalid': fecha_fin.invalid && (fecha_fin.dirty || fecha_fin.touched)}" (ngModelChange)="mostrarMensaje(fecha_fin, 'fin')"
                                (blur)="mostrarMensaje(fecha_fin, 'fin')" required>
                        </div>
                        <p class="invalid-feedback" *ngIf="showErrorMessageFin">
                            {{mensajeValidacionFin}}
                        </p>
                    </div>

                    <!-- BAR -->
                    <hr class="mt-4 mb-0">


                    <!-- MENU FIELD -->
                    <div class="col-md-6">
                        <label for="menuField" class="form-label">Estatus de proyecto</label>
                        <select class="form-select" name="proyecto.estatus" [(ngModel)]="proyecto.estatus" #estatus="ngModel" [ngClass]="{'is-invalid': estatus.invalid && (estatus.dirty || estatus.touched)}" (ngModelChange)="mostrarMensaje(estatus, 'est')" (blur)="mostrarMensaje(estatus, 'est')"
                            required>
                          <option value="">Seleccione...</option>
                          <option>Implementación</option>
                          <option>Activo</option>
                          <option>Cerrado</option>
                        </select>
                        <p class="invalid-feedback" *ngIf="showErrorMessageEst">
                            {{mensajeValidacionEst}}
                        </p>
                    </div>

                    <!-- SPACER -->
                    <div class="col-md-6 m-0 p-0"></div>
                </div>
            </form>
        </div>
    </div>

    <!-- FORM FOOTER -->
    <div class="container">
        <div class="card card-body INN-form justify-content-center mt-2 mb-4">
            <div class="row">
                <!-- FORM FOOTER CONTENT -->
                <!-- FUNCTIONS BUTTONS -->
                <div class="col ms-2 m-lg-0 d-lg-flex justify-content-lg-end align-items-lg-end">

                    <div *ngIf="opE === '1'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="validaFormulario(false, true)" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                            <i class="bi-pencil-square me-2"></i> Editar
                        </button>
                    </div>

                    <div *ngIf="opE === '1' && rol ==='Administrador'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="eliminar()" class="INN-function-button link-opacity-50-hover text-decoration-none link-danger fs-6">
                            <i class="bi-trash3 me-2"></i>Eliminar
                        </button>
                    </div>

                    <div *ngIf="opE === '2'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="validaFormulario(true, false)" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                            <i class="bi-save me-2"></i>Guardar
                        </button>
                    </div>

                    <div class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="cancelar()" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
                            <i class="bi-x-circle me-2"></i>Cancelar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- FIXED SPACE FOR MAIN FOOTER-->
    <div class="container">
        <div class="row mb-4 pb-4"></div>
    </div>

</div>
<!-- END MAIN CONTAINER -->